import { Link } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Small floating pencil icon shown ONLY to admin / editor users on article
 * card thumbnails. Clicking goes straight to the article editor.
 *
 * Use inside any card that already has `position: relative` on its outer
 * wrapper, e.g. <div className="relative">.
 */
export default function QuickEditButton({ articleId, className = '' }) {
  const { user } = useAuth();
  if (!user || !['admin', 'editor'].includes(user.role) || !articleId) return null;
  return (
    <Link
      to={`/editor/write?edit=${articleId}`}
      onClick={(e) => { e.stopPropagation(); }}
      className={`absolute top-2 right-2 z-20 w-8 h-8 rounded-full bg-black/70 hover:bg-red-600 text-white flex items-center justify-center shadow-lg backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all hover:scale-110 ${className}`}
      title="Edit article"
      data-testid={`quick-edit-${articleId}`}
    >
      <Pencil className="w-3.5 h-3.5" />
    </Link>
  );
}
